import React from 'react';
import { Table } from 'antd';

const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: 'User',
    dataIndex: ['user', 'name'],
    key: 'user',
  },
  {
    title: 'Description',
    dataIndex: 'description',
    key: 'description',
  },
  {
    title: 'Time',
    dataIndex: 'created_at',
    key: 'created_at',
    render: (val) => new Date(val).toLocaleString(),
  },
];

const ActivityTable = ({ data, loading, total, pagination, onPaginationChange }) => {
  return (
    <Table
      columns={columns}
      dataSource={data}
      loading={loading}
      scroll={{ x: 'max-content' }}
      pagination={(total > pagination.pageSize) ? {
        current: pagination.current,
        pageSize: pagination.pageSize,
        total,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50'],
        onChange: onPaginationChange,
      } : false}
      rowKey="id"
    />
  );
};

export default ActivityTable;
